module.exports = __webpack_public_path__ + "img/HKF-Logo-W.577b56cf.svg";